import * as R from 'ramda';
import { ActionType } from '../core/redux/actionType';
import { ApiReducer, makeApiReducer, makeRsaaTypes, makeApiAction } from '../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../core/api/module';
import { Endpoints } from '../core/api/endpoints';


const KEY_ACTION = ActionType.ShowLoginAnnouncementRequest;
const ACTIONS    = [
  ActionType.ShowLoginAnnouncementRequest,
  ActionType.ShowLoginAnnouncementResponse,
  ActionType.ShowLoginAnnouncementError,
];


type Payload = boolean;


/*
 * Dispatch this action to load the app's feature flags
 */
export const showLoginAnnouncementAction = () => makeApiAction<Payload>({
  method:   'GET',
  endpoint: Endpoints.ShowLoginAnnouncement,
  headers:  { 'accept': 'application/json' },
  types:    makeRsaaTypes<Payload>(ACTIONS),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assoc('showLoginAnnouncement', payload, successState);
};


export const showLoginAnnouncementReducer = makeApiReducer<Payload>(ACTIONS, KEY_ACTION, reducer);
